export default "__VITE_ASSET__B145nJUF__"